import { authentication } from './auth.reducer';
import reducerRegistry from '@store/reducerRegistry';
import store from '@store/store';

// Add reducer to redux
reducerRegistry.register('auth', authentication)

class AuthService {
	login(username, password) {

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json'},
			body: JSON.stringify({ username, password }),
		}

		return fetch('api/login', requestOptions)
		.then(this.handleResponse.bind(this))
	}

	logout() {
		const requestOptions = {
			method: 'GET'
		}

		return fetch('api/logout', requestOptions)
	}

	isAuthenticated() {
		// TODO: check cookie still exists
		const state = store.getState().auth;
		return Boolean(state.loggedIn && state.user);
	}

	handleResponse(res) {
		// console.log('authService.handleResponse()', res);
    return res.text().then(text => {
        if (!res.ok) {
          if (res.status === 401) {
            this.logout();
          }

          var error;

          switch(res.status) {
          	case 401:
          		error = 'Invalid username/password combination';
          		break;
          	case 403:
          		error = 'Account currently inactive';
          		break;
          	default:
          		error = 'An unknown error occurred';
          		break;
          }

          return Promise.reject(error);
        }
 
        const data = text && JSON.parse(text);
 
        return data;
    });

	}
}

const authService = new AuthService();

export default authService;


// WEBPACK FOOTER //
// ./src/modules/auth/auth.service.js